(function () {
  function getHeaderOffset() {
    // The sticky/fixed header only overlaps content on mobile — on PC it's
    // in normal flow, so no scroll offset is needed there.
    if (window.innerWidth >= 769) return 0;

    var header = document.querySelector('.site-header');
    var height = header ? header.getBoundingClientRect().height : 0;
    return height + 16;
  }

  function init() {
    document.querySelectorAll('a[data-target-product-handle]').forEach(function (link) {
      var handle = link.getAttribute('data-target-product-handle');
      // A dedicated attribute (not the generic data-product-handle already
      // used by product-grid-item.liquid etc.) so this only ever matches
      // the product's own showcase block, not an unrelated product grid
      // that happens to render earlier in the page.
      var productBlock = document.querySelector('[data-showcase-product-handle="' + handle + '"]');

      if (!productBlock) {
        // Not shown on this page — leave the normal href (from
        // category-link) alone so it just navigates as usual.
        return;
      }

      // Jump to this product's own category group (so its heading/context
      // is visible), not straight to the middle of the group where this
      // particular product block happens to sit. Since several categories
      // were consolidated into one content-product-showcase section
      // instance, .closest('.shopify-section') would resolve to the same
      // single wrapper for every product — .content-product-showcase__wrap
      // is the per-category group band instead, so falls back to the
      // section wrapper only if that structure isn't present.
      var target = productBlock.closest('.content-product-showcase__wrap')
        || productBlock.closest('.shopify-section')
        || productBlock;

      link.addEventListener('click', function (event) {
        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
